import React, { useState } from 'react'

type inputProps = {
    label?: string,
    placeholder?: string,
    type: string,
    getValue(word: string): void,
    error?: boolean
    value?: any
    class?: string
    size?: string
}
export default function DrugStocInput(props: inputProps) {
    const [dirty, setDirty] = useState(false)
    return (
        <div>
            {props.label ?
                <div className="md:mb-2 my-2">
                    <label htmlFor={props.label} className={`font-thin text-sm ${props.error && dirty ? 'text-red-500' : 'text-d_stock_card_blue'}`}>
                        {props.label}
                    </label>
                </div> :
                ''}
            <input
                onFocus={() => setDirty(true)}
                type={props.type}
                name={props.label}
                placeholder={props.placeholder}
                onInput={(e) => props.getValue((e.target as any).value)}
                className={`w-full px-4 py-3  border rounded-full outline-none font-thin text-sm ${props.error && dirty ? 'border-red-500' : 'border-d_stock_card_blue'}`}
                value={props.value}
                style={{height: props.size ? props.size : 'auto' }}
            />
        </div>
    )
}
